import React, { useState } from 'react';
import { GroupSelectAttachmentData } from '.';
import styles from './NewGroupSingleSelect.module.css';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { Colors } from '../colors';

const NewGroupSingleSelectAttachment: React.FC<{
    data: GroupSelectAttachmentData;
    disableButtons: boolean;
    sendMessage: (message: any) => void;
}> = ({ data, sendMessage }) => {
    const [optionSelected, setOptionSelected] = useState('');
    const choices = data.body[0].items[0].choices;

    const handleChange = (e: any, value: string) => {
        setOptionSelected(value);
        sendMessage(value);
    };

    const radioElts = choices.map((choice) => {
        const radioElt = (
            <Radio
                sx={{
                    color: Colors.PrimaryMain,
                    '&.Mui-checked': {
                        color: Colors.PrimarySelected,
                    },
                }}
            />
        );
        return (
            <FormControlLabel
                key={`multiSelectButton-${choice.title}`}
                control={radioElt}
                label={choice.title}
                value={choice.value}
                sx={{
                    alignItems: 'start',
                    marginTop: '0.4rem',
                    color: Colors.PrimaryMain,
                    '>.MuiButtonBase-root': {
                        marginTop: '-9px',
                    },
                    '&:hover': {
                        '> *': {
                            color: Colors.PrimaryLight,
                            '&.Mui-checked': {
                                color: Colors.PrimaryLight,
                            },
                        },
                        color: Colors.PrimaryLight,
                    },
                }}
            />
        );
    });

    return (
        <div className={styles.container}>
            <FormControl>
                <RadioGroup onChange={handleChange} value={optionSelected}>
                    {radioElts}
                </RadioGroup>
            </FormControl>
        </div>
    );
};

export const NewGroupSingleSelect = NewGroupSingleSelectAttachment;
